export function formatAnimalAge(options: {
  birthDate?: string | null;
  approxAgeMonths?: number | null;
}): string {
  const monthsFromBirth = options.birthDate ? monthsBetween(options.birthDate) : undefined;
  const months = monthsFromBirth ?? normalizeMonths(options.approxAgeMonths);
  if (months === undefined) return '-';
  return formatAgeFromMonths(months);
}

function normalizeMonths(value?: number | null): number | undefined {
  if (value === null || value === undefined) return undefined;
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return undefined;
  return parsed;
}

function monthsBetween(fromISO: string, toDate = new Date()): number | undefined {
  const from = new Date(fromISO);
  if (Number.isNaN(from.getTime())) return undefined;

  let months = (toDate.getFullYear() - from.getFullYear()) * 12 + (toDate.getMonth() - from.getMonth());
  if (toDate.getDate() < from.getDate()) months -= 1;
  if (months < 1) months = 1;
  return months;
}

function formatAgeFromMonths(months: number): string {
  if (months < 12) return `${months} mes${months > 1 ? 'es' : ''}`;
  const years = Math.floor(months / 12);
  const remaining = months % 12;
  const yearLabel = `año${years > 1 ? 's' : ''}`;
  if (remaining === 0) return `${years} ${yearLabel}`;
  return `${years} ${yearLabel} ${remaining} mes${remaining > 1 ? 'es' : ''}`;
}
